import type { PlayerId } from "@/types/branded";
import { generateUid } from "@/utils/index";
import type { MatchId } from "../types";
import type { Edge } from "../types/edge";
import type { RoundRobinGraph } from "../types/graph";
import type { RoundRobinNode } from "../types/node";

export const generateRoundRobinGraph = (players: PlayerId[]): RoundRobinGraph => {
  const nodes = new Map<MatchId, RoundRobinNode>();
  const edges: Edge[] = [];

  const pool = [...players];
  if (pool.length % 2 !== 0) {
    // We don't need a "Bye" player object, we just handle the odd-one-out in the loop
  }

  const numPlayers = pool.length;
  const isOdd = numPlayers % 2 !== 0;
  const rounds = isOdd ? numPlayers : numPlayers - 1;
  const matchesPerRound = Math.floor(numPlayers / 2);

  for (let r = 0; r < rounds; r++) {
    for (let m = 0; m < matchesPerRound; m++) {
      const p1Idx = (r + m) % (numPlayers - 1);
      const p2Idx = (numPlayers - 1 - m + r) % (numPlayers - 1);

      // The last player stays fixed for even counts, or we skip for odd counts
      const p1 = pool[p1Idx];
      let p2 = isOdd ? null : pool[numPlayers - 1];

      if (m !== 0 || isOdd) {
        p2 = pool[p2Idx];
      }

      if (p1 && p2) {
        const id = generateUid() as MatchId;
        nodes.set(id, { id, round: r + 1, group: 0 });
        edges.push({ kind: "seed", player: p1, to: id, slot: 0 });
        edges.push({ kind: "seed", player: p2, to: id, slot: 1 });
      }
    }
  }

  return { nodes, edges };
};
